// <!-- GRACE:MODULE_START name="ui_landing" -->
interface CardProps {
  title?: string;
  children: React.ReactNode;
}

// <!-- GRACE:CONTRACT function="Card" -->
export default function Card({ title, children }: CardProps) {
  return (
    <div className="rounded-2xl border bg-white p-4 shadow-sm">
      {title && (
        <div className="mb-3 text-sm font-semibold text-gray-700">{title}</div>
      )}
      {children}
    </div>
  );
}
// <!-- GRACE:MODULE_END name="ui_landing" -->

